export default __webpack_public_path__ + "static/media/new_3.84d0095a.jpeg";